import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
import Image from "../../../../../../base/multimedia/image/index.js";
import SearcherModal from "../../../../../searchers/searcher-modal/index.js";
import { SearcherModalProductType } from "../../../../../searchers/searcher-modal/types.js";
import Accordion from "../../../../../../structures/others/accordion/index.js";
import { ratingTemplate } from "../../../utils/index.js";
import { ImageResize, REPLACE_DESTINATION } from "../../../utils/constants.js";
import CardTransport from "./card-transport/index.js";
import PriceModal from "./price-modal/index.js";
import * as S from "./styled.js";
const CardProductModal = ({ title , subtitle , zone , literals , image , price , expandedInfoTitle , expandedInfo , offerNote , rating , ratingIco , isVisible , product , endpoint , searcher , endpointParams , toggleVisibility , smallImage  })=>{
    const { modalTitle: modalTitleLiteral = REPLACE_DESTINATION  } = literals ?? {};
    const modalTitle = zone && subtitle !== null ? modalTitleLiteral.replace(REPLACE_DESTINATION, subtitle ?? '') : modalTitleLiteral.replace(REPLACE_DESTINATION, title);
    const hotelName = zone ? title : subtitle;
    const hasAccordion = !!expandedInfo?.filter((e)=>e.hotel).length || !!(expandedInfo?.filter((e)=>e.outbound).length && expandedInfo?.filter((e)=>e.arrival).length);
    let imageModalAttributes = ImageResize.MODAL;
    if (!hasAccordion && !expandedInfoTitle && !smallImage) {
        imageModalAttributes = ImageResize.MODAL_LARGE;
    }
    return /*#__PURE__*/ _jsx(S.ModalWrapper, {
        hide: toggleVisibility,
        visible: isVisible,
        header: modalTitle,
        closeOnClickOut: true,
        closeOnEscapeKeyDown: true,
        content: /*#__PURE__*/ _jsxs("div", {
            "data-testid": "CardProductModal",
            children: [
                /*#__PURE__*/ _jsxs(S.Body, {
                    children: [
                        /*#__PURE__*/ _jsxs(S.Info, {
                            $isActivities: product == SearcherModalProductType.SEARCHER_ACTIVITIES,
                            children: [
                                /*#__PURE__*/ _jsxs(S.InfoImage, {
                                    $isActivities: product == SearcherModalProductType.SEARCHER_ACTIVITIES,
                                    children: [
                                        image && /*#__PURE__*/ _jsx(Image, {
                                            ...imageModalAttributes,
                                            ...image
                                        }),
                                        /*#__PURE__*/ _jsx(PriceModal, {
                                            literals: literals,
                                            price: price
                                        })
                                    ]
                                }),
                                !!expandedInfoTitle && /*#__PURE__*/ _jsx(S.InfoHead, {
                                    children: expandedInfoTitle
                                }),
                                !!hasAccordion && /*#__PURE__*/ _jsx(S.AccordionWrapper, {
                                    children: Children.toArray(expandedInfo?.map((info)=>{
                                        const hasTransport = !!(info.outbound && Object.keys(info.outbound).length > 0) || !!(info.arrival && Object.keys(info.arrival).length > 0);
                                        if (info.hotel) {
                                            return /*#__PURE__*/ _jsxs(S.AccordionItem, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs(S.AccordionHotelTitle, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "hotel-title",
                                                                children: hotelName
                                                            }),
                                                            ratingTemplate(!!rating, ratingIco, rating)
                                                        ]
                                                    }),
                                                    Children.toArray(info.content?.map((content)=>/*#__PURE__*/ _jsx(S.AccordionContent, {
                                                            tag: "p",
                                                            content: content
                                                        })))
                                                ]
                                            });
                                        }
                                        if (hasTransport && info.outbound && info.arrival) {
                                            return /*#__PURE__*/ _jsx(Accordion, {
                                                header: /*#__PURE__*/ _jsxs("span", {
                                                    className: "title",
                                                    children: [
                                                        info.title,
                                                        Children.toArray(info.content?.map((content)=>/*#__PURE__*/ _jsx(S.AccordionContent, {
                                                                tag: "p",
                                                                content: content
                                                            })))
                                                    ]
                                                }),
                                                content: /*#__PURE__*/ _jsx(CardTransport, {
                                                    outbound: info.outbound,
                                                    arrival: info.arrival,
                                                    product: product
                                                })
                                            });
                                        }
                                        if (info.title) {
                                            return /*#__PURE__*/ _jsx(Accordion, {
                                                header: /*#__PURE__*/ _jsxs("span", {
                                                    className: "title",
                                                    children: [
                                                        info.title,
                                                        Children.toArray(info.content?.map((content)=>/*#__PURE__*/ _jsx(S.AccordionContent, {
                                                                tag: "p",
                                                                content: content
                                                            })))
                                                    ]
                                                }),
                                                content: Children.toArray(info.descriptions?.map((description)=>/*#__PURE__*/ _jsx(S.AccordionContent, {
                                                        tag: "p",
                                                        content: description
                                                    })))
                                            });
                                        }
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(S.Searcher, {
                            children: /*#__PURE__*/ _jsx(SearcherModal, {
                                literals: literals,
                                product: product,
                                endpoint: endpoint,
                                endpointParams: endpointParams,
                                searcher: searcher
                            })
                        })
                    ]
                }),
                offerNote && /*#__PURE__*/ _jsx(S.Footer, {
                    children: offerNote
                })
            ]
        })
    });
};
export default CardProductModal;

//# sourceMappingURL=index.js.map